import './App.css';
import CategoryComponent from './CategoryComponent';
import PasswordGate from './PasswordGate';
import mealData from './resource/foodlist.json';

function App() {
  return (
    <PasswordGate>
    <div className="App">
      <header className="App-header">
        <div className="header-eyebrow">The Daily Dilemma</div>
        <h1 className="header-title">
          Aaj khane mein <em>kya khain?</em>
        </h1>
        <p className="header-sub">
          One question has troubled mankind since ages — let us help.
        </p>
      </header>

      <main className="Category-Section">
        <CategoryComponent category="Breakfast" options={mealData.Breakfast} />
        <CategoryComponent category="Lunch" options={mealData.Lunch} />
        <CategoryComponent category="Dinner" options={mealData.Dinner} />
      </main>

      <footer className="App-footer">
        <p className="footer-text">
          Made with <span>♥</span> by <span>APKD(learning program)</span>
        </p>
      </footer>
    </div>
    </PasswordGate>
  );
}

export default App;
